export const mpWxAppLifeCircle = ['onLaunch', 'onShow', 'onHide'];
export const mpWxPageLifeCircle = ['onLoad', 'onShow', 'onHide', 'onUnload'];
export const mpWxCompLifeCircle = [];
